import angular from 'angular'
import login from './login'
import home from './home'
import sysInitial from './sysinitial'
import setting from './setting'
import message from './message'
import workspace from './workspace'
import license from './license'
import loginSingle from './loginSingle'
import creditLine from './creditLine'
import certification from './certification'


import authenticationModalCtrl from './common/authenticationModalCtrl'
import certificationModalCtrl from './common/certificationModalCtrl'
import scanCodeLoginModalCtrl from './common/scanCodeLoginModalCtrl'

export default angular.module('app.main', [login, home, sysInitial, setting, message, workspace, license, loginSingle, creditLine, certification])
.controller('authenticationModalCtrl', authenticationModalCtrl)
.controller('scanCodeLoginModalCtrl', scanCodeLoginModalCtrl)
.controller('certificationModalCtrl', certificationModalCtrl).name


// WEBPACK FOOTER //
// ./src/app/main/index.js